<template>
<div class="modal fade" id="register" tabindex="-1" role="dialog" aria-labelledby="myRegister" aria-hidden="true" style="z-index:99999999;color:#fc6;" v-if="popupOpen">
    
    <div class="modal-dialog">
    <div class="modal-content modal-popup">
        <a href="javascript:void(0)" @click.prevent="closeModal($event)" class="close-link"><i class="icon_close_alt2"></i></a>
        <form action="javascript:void(0)" class="popup-form" id="myRegister" v-if="registerPopup">
            <div class="login_icon" style="font-size:21px"><i class="icon_profile"></i> Register</div>
            <input type="text" class="form-control form-white" placeholder="Name" v-model="name">
            <input type="email" class="form-control form-white" placeholder="Email" v-model="email">
            <input type="password" class="form-control form-white" placeholder="Password"  id="password1" v-model="password">
            <input type="password" class="form-control form-white" placeholder="Confirm password"  id="password2" v-model="password2">
            <div id="pass-info" class="clearfix"></div>
            <p>{{passerror}}</p>
            <p>{{errors}}</p>
            <div class="checkbox-holder text-left">
                <div class="checkbox">
                <input type="checkbox" v-model="terms" value="accept_2" id="check_2" name="check_2" />
                <label for="check_2"><span>I Agree to the </span></label> <router-link to="/privacy-policy" target="_blank"><strong>Privacy Policy</strong></router-link>
                </div>
            </div>
            <button type="submit" class="btn btn-submit" @click.prevent="register()">REGISTER</button>
            <div class="row" style="margin-top: 15px">
                
                <div class="col-md-6 col-sm-6 col-xs-6 text-right pull-right">
                <a  href="javascript:void(0)" @click.prevent="openPopup('login')">Already have an account</a>
                </div>
            </div>
        </form>
        
        <form class="popup-form" id="myOtp" v-if="otpPopup">
            <div class="login_icon" style="font-size:21px"><i class="icon_profile"></i> Verify Account</div>
            <input type="text" class="form-control form-white" placeholder="Enter OTP" @keyup="checkOTP()" v-model="otp">
            <input type="hidden" class="form-control form-white" v-model="authid">
            <p id="otpErrors">{{otpErrors}}</p>
            
            <button type="submit" class="btn btn-submit" @click.prevent="verifyOTP()">VERIFY ACCOUNT</button>
        </form>

        <form action="#" class="popup-form" id="myLogin" v-if="loginPopup">
            <div class="login_icon" style="font-size:21px"><i class="icon_lock_alt"></i> Acount Login</div>
            <input type="text" class="form-control form-white" placeholder="Email " v-model="login_email">
            <input type="password" class="form-control form-white" placeholder="Password" v-model="login_password">
            <p id="loginErrors">{{loginErrors}}</p>
            <button type="submit" class="btn btn-submit" @click.prevent="loginAccount()">LOGIN</button>
            <div class="row" style="margin-top: 15px">
                <div class="col-md-6 col-sm-6 col-xs-6">
                <a href="javascript:void(0)" @click.prevent="openPopup('forgot')" class="text-left">Forgot Password?</a>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <a  href="javascript:void(0)" @click.prevent="openPopup('register')">Create an account</a>
                </div>
            </div>
        </form>

        <form action="#" class="popup-form" id="myForgot" v-if="forgotPopup">
            <div class="login_icon" style="font-size:21px"><i class="icon_lock_alt"></i> Forgot Password</div>
            <input type="text" class="form-control form-white" placeholder="Enter Email Address" @blur="checkEmail()" v-model="forgot_email">
            <p id="forgotErrors">{{forgotErrors}}</p>
            <button type="submit" class="btn btn-submit" @click.prevent="forgotPassword()">SUBMIT</button>
        </form>

        <form action="#" class="popup-form" id="myChangePassword" v-if="changePasswordPopup">
            <div class="login_icon" style="font-size:21px"><i class="icon_lock_alt"></i> Change password</div>
            <input type="text" class="form-control form-white" placeholder="Enter Security Code" @keyup="checkCPOTP()" v-model="otp">
            <input type="password" class="form-control form-white" placeholder="Enter New Password" v-model="change_password">
            <input type="password" class="form-control form-white" placeholder="Enter Confirm Password" v-model="change_confirm_password">
            <input type="hidden" class="form-control form-white" v-model="authid">
            <p id="changeErrors">{{changeErrors}}</p>
            <button type="submit" class="btn btn-submit" @click.prevent="changePassword()">SUBMIT</button>
        </form>


    </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "PopUP",
    data() {
        return {
            name: '',
            email: '',
            password: '',
            password2: '',
            terms: '',
            passerror: '',
            otp: '',
            login_email: '',
            login_password: '',
            forgot_email: '',
            change_password: '',
            change_confirm_password:'',

        }
    },
    created() {
        this.$store.watch( getters => getters.popupOpen)
        this.$store.watch( getters => getters.registerPopup)
        this.$store.watch( getters => getters.otpPopup)
        this.$store.watch( getters => getters.loginPopup)
        this.$store.watch( getters => getters.forgotPopup)
        this.$store.watch( getters => getters.changePasswordPopup)
        
        this.$store.watch( getters => getters.authid)
        this.$store.watch( getters => getters.errors)
        this.$store.watch( getters => getters.otpErrors)
        this.$store.watch( getters => getters.loginErrors)
        this.$store.watch( getters => getters.forgotErrors)
        this.$store.watch( getters => getters.changeErrors)
        
    },
    computed: {
        ...mapGetters({
            popupOpen: 'popupOpen',
            registerPopup: 'registerPopup',
            loginPopup: 'loginPopup',
            otpPopup: 'otpPopup',
            forgotPopup: 'forgotPopup',
            changePasswordPopup: 'changePasswordPopup',
            authid: 'authid',
            errors: 'errors',
            otpErrors: 'otpErrors',
            loginErrors: 'loginErrors',
            forgotErrors: 'forgotErrors',
            changeErrors: 'changeErrors'
        })
    },
    methods: {
        closeModal(event){
            $(event.target.parentNode.parentNode.parentNode.parentNode).css({'display':'none'});
            $('div.modal-backdrop').remove();
        },
        openPopup(type){
            this.$store.dispatch('openPopup', type)
        },
        register(){
            let name = this.name;
            let email = this.email;
            let password = this.password;
            let password2 = this.password2;
            let terms = this.terms;
            if(password != password2){
                this.passerror = "Password Donot Match";
            }else if(terms === false){
                this.passerror = "Please check terms and conditions";
            }else{
                this.passerror = ''
                $("#pass-info").hide();
                let payload = { name: name , email: email, password: password, terms: terms}
                this.$store.dispatch('registerUser', payload)
            }
        },
        checkOTP(){
            let otp = this.otp
            if(!/^[0-9]+$/.test(otp)){
                $("#otpErrors").show();
                this.$store.dispatch('setOtpErrors', 'Enter Only Numbers')
                setTimeout(() => {
                    $("#otpErrors").hide();
                    this.otp = ''
                }, 3000);
            }
        },
        verifyOTP(){
            let authid = this.authid
            let otp = this.otp
            if(otp == ''){
                this.$store.dispatch('setOtpErrors', 'please Enter Otp')
            }else{
                let payload = { authid: authid, otp: otp}
                this.$store.dispatch('verifyOTP', payload)
            }
        },
        checkEmail(){
            let forgot_email = this.forgot_email
            if(!/\S+@\S+\.\S+/.test(forgot_email)){
                $("#forgotErrors").show();
                this.$store.dispatch('setForgotErrors', 'Please enter valid email')
                setTimeout(() => {
                    $("#forgotErrors").hide();
                    this.forgot_email = ''
                }, 3000);
            }
        },
        forgotPassword(){
            let forgot_email = this.forgot_email
            if(forgot_email == ''){
                $("#forgotErrors").show();
                this.$store.dispatch('setForgotErrors', 'Please enter email address')
                setTimeout(() => {
                    $("#forgotErrors").hide();
                    this.forgot_email = ''
                }, 3000);
            }else{
                this.$store.dispatch('forgotPassword', forgot_email)
            }
        },
        checkCPOTP(){
            let otp = this.otp
            if(!/^[0-9]+$/.test(otp)){
                $("#changeErrors").show();
                this.$store.dispatch('setChangeErrors', 'Enter Only Numbers')
                setTimeout(() => {
                    $("#changeErrors").hide();
                    this.otp = ''
                }, 3000);
            }
        },
        changePassword(){
            let otp = this.otp
            let authid = this.authid
            let change_password = this.change_password
            let change_confirm_password = this.change_confirm_password
            if(otp == ''){
                $("#changeErrors").show();
                this.$store.dispatch('setChangeErrors', 'Please enter your seurity code ')
                setTimeout(() => {
                    $("#changeErrors").hide();
                    this.otp = ''
                    
                }, 3000);
            }else if(change_password == ''){
                $("#changeErrors").show();
                this.$store.dispatch('setChangeErrors', 'Please enter password! ')
                setTimeout(() => {
                    $("#changeErrors").hide();
                    
                }, 2000);
            }else if(change_confirm_password == ''){
                $("#changeErrors").show();
                this.$store.dispatch('setChangeErrors', 'Please enter confirm password! ')
                setTimeout(() => {
                    $("#changeErrors").hide();
                }, 2000);
            }else if(change_password != change_confirm_password){
                $("#changeErrors").show();
                this.$store.dispatch('setChangeErrors', 'Password does not matched! ')
                setTimeout(() => {
                    $("#changeErrors").hide();
                    this.change_password = ''
                    this.change_confirm_password = ''
                }, 2000);
            }else{
                $("#changeErrors").show();
                this.$store.dispatch('changePassword',{otp:otp,change_password:change_password,authid:authid})
            }
        },
        loginAccount(){
            let user_key = sessionStorage.getItem('user_key')
            let email = this.login_email
            let password = this.login_password
            if(email == ''){
                $("#loginErrors").show();
                this.$store.dispatch('setLoginErrors', 'Please enter email address! ')
                setTimeout(() => {
                    $("#loginErrors").hide();
                }, 3000);
            }else if(!/\S+@\S+\.\S+/.test(email)){
                $("#loginErrors").show();
                this.$store.dispatch('setLoginErrors', 'Please enter valid email address! ')
                setTimeout(() => {
                    $("#loginErrors").hide();
                }, 3000);
            }else if(password == ''){
                $("#loginErrors").show();
                this.$store.dispatch('setLoginErrors', 'Please enter password! ')
                setTimeout(() => {
                    $("#loginErrors").hide();
                }, 3000);
            }else{
                this.$store.dispatch('accountLogin',{
                    user_key: user_key,
                    email : email,
                    password: password
                })
            }
        }
    },
}
</script>

<style>

</style>